function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M428.157,157.414l-95.53-69.366c-3.533-2.565-8.476-1.781-11.043,1.752c-2.566,3.533-1.78,8.477,1.753,11.043 l95.531,69.365c1.403,1.018,3.027,1.509,4.638,1.509c2.444,0,4.856-1.131,6.404-3.261 C432.476,164.923,431.691,159.979,428.157,157.414z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M192.857,119.471c-0.684-4.312-4.735-7.258-9.047-6.569L67.212,131.405c-4.312,0.684-7.253,4.735-6.569,9.047 c0.618,3.893,3.978,6.668,7.798,6.668c0.412,0,0.83-0.032,1.249-0.099l116.599-18.503 C190.602,127.834,193.543,123.784,192.857,119.471z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M508.737,132.553L331.322,3.731c-1.696-1.231-3.81-1.741-5.884-1.41c-2.07,0.329-3.926,1.466-5.159,3.162l-77.371,106.558 l-10.653-67.129c-0.328-2.071-1.466-3.926-3.163-5.159s-3.815-1.738-5.884-1.41L6.668,72.706 c-4.312,0.684-7.253,4.735-6.569,9.046L42.39,348.265c0.329,2.071,1.466,3.926,3.162,5.159c1.359,0.987,2.986,1.508,4.645,1.508 c0.412,0,0.826-0.033,1.239-0.098l49.757-7.896v84.826c0,4.366,3.54,7.906,7.906,7.906H328.35c4.367,0,7.906-3.54,7.906-7.906 v-22.293c5.424-3.115,10.547-6.711,15.304-10.779l19.699,19.7l-6.335,6.335c-3.087,3.087-3.087,8.093,0,11.181l71.554,71.554 c1.544,1.544,3.567,2.316,5.591,2.316c2.023,0,4.047-0.772,5.591-2.316l23.852-23.852c1.482-1.482,2.315-3.493,2.315-5.59 c0-2.097-0.833-4.108-2.315-5.59l-71.555-71.554c-1.483-1.483-3.494-2.316-5.591-2.316c-2.097,0-4.107,0.833-5.591,2.316 l-6.335,6.335l-19.699-19.699c15.601-18.212,24.111-41.137,24.111-65.374c0-2.593-0.108-5.219-0.311-7.84L510.49,143.594 C513.056,140.061,512.271,135.117,508.737,132.553z M394.365,417.648l60.374,60.374l-12.671,12.671l-60.373-60.374 L394.365,417.648z M101.194,161.916v32.401l-23.409,3.715c-4.312,0.684-7.253,4.735-6.569,9.047 c0.618,3.893,3.978,6.668,7.798,6.668c0.412,0,0.83-0.032,1.249-0.099l20.931-3.321v52.297l-12.837,2.036 c-4.312,0.684-7.253,4.735-6.569,9.047c0.618,3.893,3.978,6.668,7.798,6.668c0.412,0,0.83-0.032,1.249-0.099l10.359-1.643v52.297 l-44.428,7.05L16.954,87.083L217.88,55.199l11.891,74.935l-17.337,23.876H109.099C104.733,154.011,101.194,157.55,101.194,161.916 z M320.445,423.859h-203.44V337.68v-68.306v-68.305v-31.245h99.445c0.002,0,0.004,0.001,0.006,0.001 c0.003,0,0.006-0.001,0.008-0.001h26.352h63.256c0.002,0,0.004,0.001,0.006,0.001c0.003,0,0.006-0.001,0.01-0.001h14.355v8.26 v49.379c-10.927-3.974-22.402-5.988-34.258-5.988c-2.209,0-4.408,0.081-6.595,0.223c-0.59-0.14-1.204-0.223-1.837-0.223H159.695 c-4.366,0-7.906,3.54-7.906,7.906c0,4.366,3.54,7.906,7.906,7.906h72.318c-8.542,5.461-16.309,12.243-22.991,20.213 c-7.884,9.4-13.876,19.955-17.874,31.437h-31.452c-4.366,0-7.906,3.54-7.906,7.906c0,4.366,3.54,7.906,7.906,7.906h27.336 c-1.003,5.733-1.51,11.552-1.51,17.393c0,11.865,2.011,23.34,5.978,34.258h-31.803c-4.366,0-7.906,3.54-7.906,7.906 c0,4.366,3.54,7.906,7.906,7.906h39.156c17.95,31.328,50.971,50.596,87.335,50.596c11.864,0,23.339-2.011,34.258-5.978V423.859z  M346.188,382.14c-0.001,0.001-0.002,0.002-0.003,0.003c-6.308,6.308-13.52,11.556-21.433,15.601 c-12.005,6.137-24.98,9.249-38.565,9.249c-32.039,0-61.01-17.737-75.606-46.289c-0.001-0.002-0.002-0.004-0.003-0.006 c-6.135-12.003-9.245-24.976-9.245-38.559c0-7.835,1.079-15.623,3.209-23.145c3.273-11.563,8.858-22.107,16.598-31.337 c16.185-19.302,39.894-30.372,65.048-30.372c13.569,0,26.545,3.116,38.564,9.263c25.594,13.089,42.713,37.895,45.788,66.358 c0.001,0.005,0.002,0.011,0.002,0.017c0.331,3.074,0.5,6.174,0.5,9.216C371.041,344.806,362.215,366.113,346.188,382.14z  M382.541,292.896c-7.362-24.39-23.782-45.177-46.285-58.078v-41.224l42.976,31.204c1.403,1.018,3.027,1.509,4.638,1.509 c2.444,0,4.856-1.131,6.404-3.261c2.566-3.533,1.78-8.477-1.753-11.043l-52.265-37.949v-12.136c0-4.366-3.539-7.906-7.906-7.906 h-19.696l-15.664-11.374c-3.533-2.565-8.478-1.782-11.043,1.752c-2.151,2.962-1.94,6.91,0.263,9.622h-39.395h-10.843 l12.514-17.234c0.001-0.001,0.002-0.002,0.003-0.004l83.94-115.603l164.621,119.531L382.541,292.896z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M286.187,255.205c-36.908,0-66.935,30.027-66.935,66.935c0,36.908,30.027,66.935,66.935,66.935 c36.908,0,66.935-30.027,66.935-66.935C353.122,285.231,323.095,255.205,286.187,255.205z M286.187,373.263 c-28.19,0-51.123-22.934-51.123-51.123c0-28.19,22.934-51.123,51.123-51.123c28.19,0,51.123,22.934,51.123,51.123 C337.31,350.329,314.376,373.263,286.187,373.263z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M308.643,320.766c-3.088-3.087-8.093-3.087-11.182,0l-21.082,21.082c-3.087,3.087-3.087,8.093,0,11.18 c1.544,1.543,3.568,2.316,5.591,2.316s4.047-0.772,5.591-2.316l21.082-21.082C311.731,328.858,311.731,323.852,308.643,320.766z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M300.21,287.035c-3.088-3.087-8.093-3.087-11.181,0l-23.19,23.19c-3.087,3.087-3.087,8.093,0,11.18 c1.544,1.543,3.568,2.316,5.591,2.316c2.023,0,4.047-0.772,5.591-2.316l23.189-23.19 C303.298,295.127,303.298,290.121,300.21,287.035z"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.f70eb2a7.svg";
export { ForwardRef as ReactComponent };